import './editor.scss';
import './style.scss';

(function ($) {
  $(document).ready(function () {
    $('.rd-testimonial .logos').each(function () {
      const $slider = $(this);

      new Swiper(this, {
      speed: 1200,
      duration: 5000,
      grabCursor: true,
      loop: true,
      autoplay: true,
      navigation: {
        nextEl: $slider.find('.swiper-next')[0],
        prevEl: $slider.find('.swiper-prev')[0],
      },
      breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 50,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 100,
        },
        840: {
          slidesPerView: 5,
          spaceBetween: 100,
        },
      },
    });
    });
  });
})(jQuery);